export default __webpack_public_path__ + "static/media/exhibition1.0c56a3e7.png";